import React, { useEffect } from 'react'
const EndMeeting = () => {

    useEffect(() => {
        const eventData = JSON.stringify({ eventType: "growkarma_zoomMeetingEnd" });
        window.top.postMessage(eventData, '*');
    }, [])

    return (<div></div>)
}
export default EndMeeting